import auth from "./auth";
import academic from "./academic";
import administrasi from "./administrasi";

export default [
  ...auth,
  ...academic,
  ...administrasi,
  {
    path: "/dashboard",
    name: "dashboard-overview",
    meta: { title: "Dashboard", authRequired: true },
    component: () => import("../views/dashboards/overview"),
  },
  {
    path: "/",
    redirect: { name: "dashboard-overview" },
  },
  {
    path: "/login",
    name: "Login",
    meta: { title: "Login", authRequired: true },
    component: () => import("../views/account/login"),
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "404 Error Page" },
    component: require("../views/utility/404").default,
  },
  {
    path: "/rekruitasi/calon-siswa-list",
    name: "calon-siswa-list",
    meta: { title: "Rekruitasi", authRequired: true },
    component: () => import("../views/calon-siswa/calon-siswa-list"),
  },
  {
    path: "/rekruitasi/calon-siswa-details",
    name: "calon-siswa-add",
    meta: { title: "Tambah Calon Siswa", authRequired: true },
    component: () => import("../views/calon-siswa/calon-siswa-details"),
  },
  {
    path: "/rekruitasi/calon-siswa-details/:id",
    name: "calon-siswa-view",
    meta: { title: "Detail Calon Siswa", authRequired: true },
    component: () => import("../views/calon-siswa/calon-siswa-details"),
  },
  {
    path: "/pengaturan",
    name: "pengaturan",
    meta: { title: "Pengaturan", authRequired: true },
    component: () => import("../views/pengaturan/index"),
  },
  {
    path: "/administrasi/passport",
    name: "passport",
    meta: { title: "Job Details", authRequired: true },
    component: () => import("../views/utility/coming-soon"),
  },
  {
    path: "/master-data-kumiai/kumiai-list",
    name: "Kumiai List",
    meta: { title: "Kumiai List", authRequired: true },
    component: () => import("../views/kumiai/kumiai-list"),
  },
  {
    path: "/master-data-perusahaan/perusahaan-list",
    name: "Perusahaan List",
    meta: { title: "Perusahaan List", authRequired: true },
    component: () => import("../views/perusahaan/perusahaan-list"),
  },
  {
    path: "/master-data-perusahaan/jenis-kerja-list",
    name: "Jenis Kerja List",
    meta: { title: "Jenis Kerja List", authRequired: true },
    component: () => import("../views/jenis-kerja/jenis-kerja-list"),
  },
  {
    path: "/master-data-kumiai/kumiai-details/:id",
    name: "kumiai-details",
    meta: { title: "Detail Kumiai", authRequired: true },
    component: () => import("../views/kumiai/kumiai-details"),
  },
  {
    path: "/master-data-kumiai/kumiai-details/:id/company/:company",
    name: "kumiai-company",
    meta: { title: "Detail Perusahaan", authRequired: true },
    component: () => import("../views/kumiai/kumiai-company-details"),
  },
  {
    path: "/pengaturan/users-list",
    name: "User List",
    meta: { title: "Users List", authRequired: true },
    component: () => import("../views/users/users-list"),
  },
  {
    path: "/pengaturan/users-details",
    name: "User Add",
    meta: { title: "Users Add", authRequired: true },
    component: () => import("../views/users/users-details"),
  },
  {
    path: "/pengaturan/users-details/:id",
    name: "User Details",
    meta: { title: "Users Details", authRequired: true },
    component: () => import("../views/users/users-details"),
  },
  {
    path: "/pengaturan/role-list",
    name: "Role List",
    meta: { title: "Role List", authRequired: true },
    component: () => import("../views/roles/role-list"),
  },
  {
    path: "/pengaturan/menu-setup-list",
    name: "Menu Setup List",
    meta: { title: "Menu Setup List", authRequired: true },
    component: () => import("../views/menu-setup/menu-setup-list"),
  },
  {
    path: "/pengaturan/menu-setup-details/:id",
    name: "Menu Setup Details",
    meta: { title: "Menu Setup Details", authRequired: true },
    component: () => import("../views/menu-setup/menu-setup-details"),
  },
  {
    path: "/pages/maintenance",
    name: "Maintenance",
    meta: { title: "Maintenance Page", authRequired: true },
    component: () => import("../views/utility/maintenance"),
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { title: "Coming Soon", authRequired: true },
    component: () => import("../views/utility/coming-soon"),
  },
  {
    path: "/pages/404",
    name: "Error-404",
    meta: { title: "404 Error Page", authRequired: true },
    component: () => import("../views/utility/404"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { title: "500 Error Page", authRequired: true },
    component: () => import("../views/utility/500"),
  },
];
